/**
 * @generated SignedSource<<9ce487c99c631233415ba28414cd2637>>
 * @relayHash 31980ab6c38bae595f082e75d7d0e4e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702

import type { ConcreteRequest, Query } from 'relay-runtime';
export type userpicker_forge_ui_usersQuery$variables = {
  accountIds: ReadonlyArray<string>;
};
export type userpicker_forge_ui_usersQuery$data = {
  readonly users: ReadonlyArray<{
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  }> | null | undefined;
};
export type userpicker_forge_ui_usersQuery = {
  response: userpicker_forge_ui_usersQuery$data;
  variables: userpicker_forge_ui_usersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "userpicker_forge_ui_usersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userpicker_forge_ui_usersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702",
    "metadata": {},
    "name": "userpicker_forge_ui_usersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bfc99cc46adea62c7037b11c133b2a46";

export default node;
